export default Object.freeze({
  Search: 1,
  Add: 2,
  Modify: 3,
  Activate: 4,
  Deactivate: 5,
  Remove: 6,
  Count: 7,
  CancelDelegation: 8,
});
